import {
    RIDE_STATUS_COLORS, RIDE_STATUS_LABELS, RIDE_STATUS_STYLE_OVERRIDES, DRIVER_STATUS_COLORS,
    getSettingsRideStatusColors, getSettingsDriverStatusColors
} from '../config/appConstants';

export const getRideStatus = (ride) => {
    // Use server-side status field if available
    if (ride.status) {
        // Normalize server status to our display keys
        const statusMap = {
            'Open': 'open',
            'Assigned': 'assigned',
            'AtPickup': 'atPickup',
            'PickedUp': 'inProgress',
            'DroppedOff': 'droppedOff',
            'Completed': 'completed',
            'Canceled': 'canceled',
            'PaymentPending': 'paymentPending',
        };
        // Handle AtStop1-AtStop10
        if (ride.status.startsWith('AtStop')) {
            return ride.status.toLowerCase(); // e.g. "atstop1"
        }
        return statusMap[ride.status] || ride.status.toLowerCase();
    }

    // Fallback: compute from fields (for rides created before Status field)
    const parseAsUTC = (dateStr) => {
        if (!dateStr) return new Date();
        let isoStr = dateStr.replace(' ', 'T');
        if (!isoStr.endsWith('Z') && !isoStr.includes('+') && !isoStr.includes('-', 10)) {
            isoStr = isoStr.split('.')[0] + 'Z';
        }
        return new Date(isoStr);
    };

    const scheduledTime = parseAsUTC(ride.scheduledFor).getTime();
    const fifteenMinutesFromNow = Date.now() + 15 * 60 * 1000;

    return ride.canceled ? 'canceled' :
        ride.completed ? 'completed' :
            ride.dropOffTime && !ride.completed ? 'droppedOff' :
                ride.pickupTime && !ride.dropOffTime ? 'inProgress' :
                    ride.arrivedAtPickupTime && !ride.pickupTime ? 'atPickup' :
                        !ride.pickupTime && ((!ride.reassigned && ride.assignedToId) || (ride.reassigned && ride.reassignedToId))
                            ? scheduledTime > fifteenMinutesFromNow ? 'scheduled' : 'arriving' :
                            (!ride.reassigned && !ride.assignedToId) || (ride.reassigned && !ride.reassignedToId) ? 'open'
                                : 'unknown';
}

export const getRideStatusColor = (status, settings) => {
    const colors = settings ? getSettingsRideStatusColors(settings) : RIDE_STATUS_COLORS;
    // Handle AtStop statuses
    if (status && status.startsWith('atstop')) return 'info';
    return colors[status] || 'default';
}

export const getRideStatusLabel = (status, settings) => {
    // Labels are static - not configurable from settings
    const labels = RIDE_STATUS_LABELS;
    // Handle AtStop statuses (atstop1 -> "At Stop 1")
    if (status && status.startsWith('atstop')) {
        const stopNum = status.replace('atstop', '');
        return `At Stop ${stopNum}`;
    }
    return labels[status] || status || 'Unknown';
}

export const getRideStatusStyle = (status) => {
    return RIDE_STATUS_STYLE_OVERRIDES[status] || {};
}

export const getDriverStatusColor = (status, settings) => {
    const colors = settings ? getSettingsDriverStatusColors(settings) : DRIVER_STATUS_COLORS;
    return colors[status] || 'default';
}